'use client'

import { createContext, type ReactNode } from 'react'
import type { GetUnity } from '@/http/zamply/unity/get-unity-schema'

export const UnityContext = createContext<GetUnity | null>(null)

interface UnityProviderProps {
  children: ReactNode
  data: GetUnity | null
}

export function UnityProvider({ children, data }: UnityProviderProps) {
  return <UnityContext.Provider value={data}>{children}</UnityContext.Provider>
}
